import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { useLayers } from '../../hooks/index.js';
import { CameraPathNode } from '../../types/index.js';

export type CameraPathProps = GraphNodeProps<CameraPathNode>;

export const CameraPath: React.FC<CameraPathProps> = (props) => {
  const layers = useLayers();
  return (
    <camerapath
      {...props}
      visible={props.visible !== false && layers.isEnabled(FShallowNodeTypesEnum.CameraPath)}
    ></camerapath>
  );
};
